import React from 'react';

import useDispensaryProducts from 'src/dispensary/hooks/use-dispensary-products';
import usePaths from 'src/hooks/use-paths';
import { ProductCarousel } from 'src/components/carousel-v2/types/product-carousel';

export function SpecialsCarousel(props) {
  const { loading, products } = useDispensaryProducts({
    filters: { isOnSpecial: true, useCache: true },
    perPage: 25,
  });
  const { href } = usePaths({ specials: true });
  const label = `Items on Sale`;

  if (!products?.length && !loading) {
    return null;
  }

  return (
    <ProductCarousel
      products={products}
      isLoading={loading}
      href={href}
      hideTitle={props?.showTitle === false}
      hideLink={props?.showLink === false}
      title={label}
    />
  );
}
